export type Quadrant = 'priority-integrated-action' | 'steward-manage' | 'secure-build-resilience' | 'monitor';

export function getQuadrant(dependencies: number, impactOnNature: number): Quadrant {
    const highDependencies = dependencies >= 0.5;
    const highImpact = impactOnNature >= 0.5;

    if (highDependencies && highImpact) return 'priority-integrated-action';
    if (!highDependencies && highImpact) return 'steward-manage';
    if (highDependencies && !highImpact) return 'secure-build-resilience';
    return 'monitor';
}

const QUADRANT_FILL_CLASSES: Record<Quadrant, string> = {
    'priority-integrated-action': 'fill-status-very-high',
    'steward-manage': 'fill-status-medium',
    'secure-build-resilience': 'fill-status-medium',
    monitor: 'fill-status-very-low',
};

export function getQuadrantFillClass(quadrant: Quadrant): string {
    return QUADRANT_FILL_CLASSES[quadrant];
}

const QUADRANT_TEXT_CLASSES: Record<Quadrant, string> = {
    'priority-integrated-action': 'text-status-very-high',
    'steward-manage': 'text-status-medium',
    'secure-build-resilience': 'text-status-medium',
    monitor: 'text-status-very-low',
};

export function getQuadrantTextClass(quadrant: Quadrant): string {
    return QUADRANT_TEXT_CLASSES[quadrant];
}

const QUADRANT_STROKE_CLASSES: Record<Quadrant, string> = {
    'priority-integrated-action': 'stroke-status-very-high',
    'steward-manage': 'stroke-status-medium',
    'secure-build-resilience': 'stroke-status-medium',
    monitor: 'stroke-status-very-low',
};

export function getQuadrantStrokeClass(quadrant: Quadrant): string {
    return QUADRANT_STROKE_CLASSES[quadrant];
}
